module.exports = __webpack_public_path__ + "img/ring_y_l_1_null@3x.ae892fad.png";